import styled from 'styled-components';

import { Card } from '@atom/card/card';
import { ColorEnum } from '@enum/style/color.enum';

export const DashboardLogCard = styled(Card)`
  background-color: ${ColorEnum.Black3};
  overflow: hidden;

  & .ant-card-head {
    padding: 16px 24px;
    background-color: ${ColorEnum.Black3};
  }

  & .ant-card-head-title {
    font-size: 28px;
  }

  & .ant-card-body {
    padding: 0;
  }
`;

export const FooterWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  background-color: ${ColorEnum.Black3};
  padding: 24px;
`;
